import React, { useState, useEffect } from 'react'
import "./Register.css";
import { Link, useHistory } from "react-router-dom";
import { auth,db } from './firebase';
import Skblack from './Skblack.jpeg'
import VisibilityIcon from '@mui/icons-material/Visibility';
import VisibilityOffIcon from '@mui/icons-material/VisibilityOff';
import EmailIcon from '@mui/icons-material/Email';
import LockIcon from '@mui/icons-material/Lock';
import Tooltip from "@mui/material/Tooltip";
import PersonIcon from '@mui/icons-material/Person';

function Register() {
    const history = useHistory();
    const [fname,setFname]=useState('')
    const [lname,setLname]=useState('')
    const [email, setEmail] = useState('');
    const [password, setPassword] = useState('');
    const [showPass, setShowPass] = useState(false);
    const [passType, setPassType] = useState('')
    useEffect(() => {
        if (showPass) {
            setPassType('text')
        }
        else {
            setPassType('password')
        }
    }, [showPass])
    const register = (event) => {
        event.preventDefault();
        auth
            .createUserWithEmailAndPassword(email, password)
            .then(auth => {
                history.push('/');
            })
            .catch((e) => alert(e.message));
            db.collection('register')
            .doc(`${email}`)
            .set({
                fname:fname,
                lname:lname,
                email:email,

            })
    };
    return (
        <div className="login">
            <Link to="/">
                {/* "https://upload.wikimedia.org/wikipedia/commons/thumb/a/a9/Amazon_logo.svg/1024px-Amazon_logo.svg.png" */}
                <img className="login__logo" src={Skblack} />
            </Link>
            <div className="login__container">
                <form>
                    <h2>Sign-Up</h2>
                    {/* {`fname is : ${fname} , lmane is ${lname}`} */}
                    <h5><PersonIcon style={{'color':'#aaa'}}/></h5>
                    <span><input className='register__fname'style={{'width':'125px'}} type='text' placeholder='First name' onChange={(e)=>{setFname(e.target.value)}}/> <input className='register__fname' type='text' placeholder='Last name' onChange={(e)=>{setLname(e.target.value)}} style={{'width':'125px'}}/></span>
                    {/* <h5><EmailIcon /></h5> */}
                    <p className='inputWithIcon'>
                    <input className='register__email' value={email} placeholder='Enter your email...' onChange={event => setEmail(event.target.value)} type="text" />
                    <i className='email__icon'><EmailIcon /></i>
                    </p>
                    {/* <h5><LockIcon /></h5> */}
                    <p className='inputWithIcon'>
                    <input className='register__password register__password2' placeholder='Enter password here...' type={passType} onChange={event => setPassword(event.target.value)}
                        value={password} id='pwd' 
                    />
                    <i className='lock__icon'><LockIcon /></i>

                        <i className='visible__icon'>{showPass ?
                            <Tooltip title='Hide password'>
                                <VisibilityOffIcon style={{ 'color': 'red' }} className='ml-1' onClick={() => setShowPass(v => !v)} />
                            </Tooltip>
                            :
                            <Tooltip title='Show password'>
                                <VisibilityIcon className='ml-1' style={{ 'color': 'green' }}
                                    onClick={() => setShowPass(v => !v)} />
                            </Tooltip>
                        }
                        </i>
                    </p>
                    {/* <button onClick={login} type="submit" className="login__signInButton"> Sign-Up</button> */}
                </form>
                {/* <center><p className='mt-2'>
                    <Link to="/ForgotPassword" >
                        Forgot Password?
                </Link>
                </p></center> */}
                <span></span>
                <p>By signing-in you are agree to SK's Grocery Condition of Use & Sale. Please our Privacy Notice,our Cookie Notice and our interest-Based Ads Notice</p>
                <button onClick={register} className="login__registerButton">Create Your SK's account</button>
                <center><p className='mt-1'>Already have an account? <span> <Link to='/login'>Sign in</Link></span></p></center>
            </div>
        </div>
    )
}

export default Register
